import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTabs,{attrs:{"background-color":"white","color":"green darken-3","right":""}},[_vm._l((_vm.list),function(item,key){return _c(VTab,{key:key},[_vm._v(_vm._s(item))])}),_vm._l((_vm.list),function(item,key){return _c(VTabItem,{key:item},[_vm._t("default",null,{"user":_vm.$user,"tabId":key,"tabName":item})],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }